import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'react-apollo';

// Redux
import { connect } from 'react-redux';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './SimilarListings.css';

import HomeSlider from '../../../components/Home/HomeSlider';

// Redux Actions
import { setStickyBottom } from '../../../actions/Sticky/StrickyActions';
import { closeWishListModal } from '../../../actions/WishList/modalActions';
class SimilarListings extends Component {

    static propTypes = {
        data: PropTypes.any
    };

    static defaultProps = {
        data: null
    };

    constructor(props) {
        super(props);
        this.state = {
            smallDevice: false
        };
        this.handleResize = this.handleResize.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        const { setStickyBottom } = this.props;
        let sticky = document.querySelector('[data-sticky-bottom]'), stickyBottom = 1615; //2474;
        stickyBottom = (sticky.getBoundingClientRect().top);
        let isBrowser = typeof window !== 'undefined';
        if (isBrowser) {
            this.handleResize();
            window.addEventListener('resize', this.handleResize);
            document.addEventListener('scroll', this.handleScroll);
        }
        stickyBottom = (sticky.getBoundingClientRect().top > stickyBottom) ? sticky.getBoundingClientRect().top : stickyBottom;
        setStickyBottom(stickyBottom);
    }

    handleScroll() {
        const { setStickyBottom } = this.props;
        let sticky = document.querySelector('[data-sticky-bottom]');
        if (!sticky) return;
        let stickyBottom = sticky.getBoundingClientRect().top || 1615;
        let bottomElementHeight = 600;
        let windowHeight = document.documentElement.getBoundingClientRect().height || 3000;
        
        if ((windowHeight - bottomElementHeight) > stickyBottom) {
            stickyBottom = windowHeight - bottomElementHeight;
            setStickyBottom(stickyBottom + 20);
        }
    }

    componentWillUnmount() {
        const { closeWishListModal } = this.props
        let isBrowser = typeof window !== 'undefined';
        if (isBrowser) {
            window.removeEventListener('resize', this.handleResize);
            document.removeEventListener('scroll', this.handleScroll);
        }
        closeWishListModal()
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { setStickyBottom } = this.props;
        let sticky = document.querySelector('[data-sticky-bottom]'), stickyBottom = 1615; //2474;
        stickyBottom = (sticky.getBoundingClientRect().top);
        setStickyBottom(stickyBottom);
    }

    handleResize(e) {
        let isBrowser = typeof window !== 'undefined';
        let smallDevice = isBrowser ? window.matchMedia('(max-width: 768px)').matches : false;
        this.setState({ smallDevice });
    }

    render() {
        const { data, similiarListPadding } = this.props;
        console.log(data,"data");
        return (
            <div data-sticky-bottom>
                <HomeSlider data={data} similiarListPadding={s.paddingmobile} className={s.similarListingMargin} />
            </div>
        );
    }
}

const mapState = (state) => ({
    isAuthenticated: state.runtime.isAuthenticated
});

const mapDispatch = {
    setStickyBottom,
    closeWishListModal
};

export default compose(
    withStyles(s),
    connect(mapState, mapDispatch)
)(SimilarListings);